import { useTheme, useMediaQuery } from '@mui/material';
import CrowdfundingLandingPageDesktop from './CrowdfundingLandingPageDesktop';
import CrowdfundingLandingPageMobile from './CrowdfundingLandingPageMobile';

export default function CrowdfundingLandingPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <CrowdfundingLandingPageMobile />
    : <CrowdfundingLandingPageDesktop />;
}